import React from 'react';

import type { Autocomplete } from '@mui/material';
import { TypeAheadAutoComplete } from '../components/inputs/autocomplete/TypeAheadAutoComplete';
import type { InputLabelBaseProps } from '../components/inputs/InputLabelBase';
import type { IndustryValue } from './LanguageIndustryAutoComplete';
import { useIndustryCodeSearch } from './useIndustryCodeSearch';

export interface SicIndustryAutoCompleteProps {
  label: string;
  name: string;
  required?: boolean;
  onSelect: (value: IndustryValue) => void;
  autoCompleteProps?: React.ComponentType<typeof Autocomplete> | object;
  inputLabelBaseProps?: Omit<InputLabelBaseProps, 'children'>;
}

// Helper function to filter and transform industry codes
const filterIndustryCodes = (filtered: IndustryValue[], industry: any) => {
  if (industry?.sicCode) {
    filtered.push({
      label: `${industry?.sicCode} ${
        industry?.sicSecondaryDesc && `[${industry?.sicSecondaryDesc}]`
      }`,
      value: industry?.sicCode,
      meta: industry,
    });
  }

  return filtered;
};

const mapToSicOptions = (content: any[]) =>
  content.reduce(filterIndustryCodes, [] as IndustryValue[]);

export const SicIndustryAutoComplete = (
  props: SicIndustryAutoCompleteProps
) => {
  const getIndustryCodes = useIndustryCodeSearch(mapToSicOptions);

  return <TypeAheadAutoComplete asyncFunction={getIndustryCodes} {...props} />;
};
